import { CmiFiltersConfig } from '@epicuro-next/models/cmi';
import { IConfigurations } from '@epicuro-next/platform/configuration';

export const CMI_PAGE_NAMESPACE = 'cmi-page';

export enum CmiPageConfigurationKeys {
  CmiFilters = 'cmi-filters',
  MaxVariantImages = 'max-variant-images',
}

export interface CmiPageConfigurations
  extends IConfigurations<CmiPageConfigurationKeys> {
  [CmiPageConfigurationKeys.CmiFilters]: CmiFiltersConfig[];
  [CmiPageConfigurationKeys.MaxVariantImages]: number;
}

export const cmiPageConfigurationsDefaultValues = {
  [CmiPageConfigurationKeys.CmiFilters]: '[]' as unknown as CmiFiltersConfig[],
  [CmiPageConfigurationKeys.MaxVariantImages]: 15,
};
